export function initNotificationsPanel(root: HTMLElement): void {
    const markAllUrl = root.dataset.markAllUrl ?? '';

    if (!markAllUrl) {
        return;
    }

    $('#markAll')
        .off('click.systemNotifications')
        .on('click.systemNotifications', (event) => {
            event.preventDefault();
            $.nette.ajax({ url: markAllUrl });
        });
}
